import PropTypes from 'prop-types'
import React, { useEffect } from "react"

import { connect } from "react-redux"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import {
  getProfile,
} from "../../store/auth/profile/actions"


const SidebarContent = props => {
  const { role } = props
  const user = JSON.parse(localStorage.getItem("user"));
  
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const { onGetProfile } = props
    if (user!=null)
    onGetProfile(user.user)

    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()

  }, [props.location.pathname])

  useEffect(() => {
      
  }, [role])


  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show")

        const parent3 = parent2.parentElement

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.add("mm-active")
          }
        }
      }
      return false
    }
    return false
  }

  return (
    <React.Fragment>
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">{props.t("Menu")} </li>
	  {(role.includes("Administrator") || role.includes("Beta-tester") || role.includes("Subscriber")) &&

           <li>
                      <Link to="/home" className=" waves-effect">
                        <i class="fas fa-home" aria-hidden="true"></i>
                         <span>{props.t("Dashboard")}</span>
                      </Link>
                    </li>
               }

	          {role.includes("Administrator") &&
 <li>
                      <Link to="/admin" className=" waves-effect">
                        <i className="mdi mdi-hammer-wrench"></i>
                        <span>{props.t("Admin")}</span>
                      </Link>
                    </li>
                  }

	   {(role.includes("Administrator") || role.includes("Beta-tester") || role.includes("Subscriber")) &&

	   <li>
                      <Link to="/designer" className=" waves-effect">
                        <i class="bx bx-pen" aria-hidden="true"></i>
                         <span>{props.t("Designer")}</span>
                      </Link>
                    </li>
	       }

	   {(role.includes("Administrator") || role.includes("Beta-tester") || role.includes("Subscriber")) &&

          <li>
            <Link to="/calendar" className=" waves-effect">
              <i className="bx bx-calendar"></i>
              <span>{props.t("Calendar")}</span>
            </Link>
          </li>
	   }

{(role.includes("Administrator") || role.includes("Beta-tester") || role.includes("Subscriber")) &&

          <li>
            <Link to="/journal" className=" waves-effect">
              <i className="bx bx-notepad"></i>
              <span>{props.t("Journal")}</span>
            </Link>
          </li>
           }
	   {(role.includes("Administrator") || role.includes("Beta-tester") || role.includes("Subscriber")) &&
           <React.Fragment>
             <li>
               <a className="waves-effect" style={{cursor: "default", pointerEvents: "none"}}>
                 <i className="fa fa-leaf" aria-hidden="true"></i>
                 <span>{props.t("Plants")}</span>
               </a>
             </li>
             <li>
               <Link to="/plants/inventory" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Inventory")}</span>
               </Link>
             </li>
             <li>
               <Link to="/plants/areas" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Areas")}</span>
               </Link>
             </li>
             <li>
               <Link to="/plants/guild" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Guilds")}</span>
               </Link>
             </li>
             <li>
               <Link to="/plants/crop-planner" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Crop Planner")}</span>
               </Link>
             </li>
             <li>
               <Link to="/plants/log-harvest" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Log Harvest")}</span>
               </Link>
             </li>
             <li>
               <Link to="/plants/custom-plant" className="waves-effect" style={{paddingLeft: "2.5rem"}}>
                 <span>{props.t("Custom Plant")}</span>
               </Link>
             </li>
           </React.Fragment>
       }


        </ul>
      </div>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  role: PropTypes.array,
}

const mapStateToProps = (state) => {
  if (state.Profile.user) { 
    return ({
      role:state.Profile.user.userRole})
  } else {
	  return ({ role: ["Subscriber"] })
  }

}

const mapDispatchToProps = dispatch => ({
  onGetProfile: (username) => dispatch (getProfile(username)),
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withTranslation()(SidebarContent)))


